import { render, staticRenderFns } from "./stock-details.vue?vue&type=template&id=4377b544&scoped=true"
import script from "./stock-details.vue?vue&type=script&lang=js"
export * from "./stock-details.vue?vue&type=script&lang=js"
import style0 from "./stock-details.vue?vue&type=style&index=0&id=4377b544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4377b544",
  null
  
)

export default component.exports